// Πόντοι ανά νίκη/ήττα: multiplayer = πλήρης αξία, AI = μειωμένη
export const WIN_VALUES = {
  MULTIPLAYER: 1,
  AI: 0.25,
} as const;

export const LOSS_VALUES = {
  MULTIPLAYER: -0.5,  // Ήττα vs παίκτη: χάνεις μισό πόντο
  AI: -0.1,           // Ήττα vs AI: χάνεις ελάχιστα
} as const;

export const RANK_TIERS = [
  { id: "archarios" as const, name: "Αρχάριος", emoji: "🌱", minWins: 0, color: "text-muted-foreground", bgColor: "bg-muted" },
  { id: "archarios" as const, name: "Παίκτης", emoji: "🎲", minWins: 5, color: "text-stone-400", bgColor: "bg-stone-500/10" },
  { id: "machitis" as const, name: "Μαχητής", emoji: "⚔️", minWins: 15, color: "text-emerald-500", bgColor: "bg-emerald-500/10" },
  { id: "machitis" as const, name: "Δυναμίτης", emoji: "💥", minWins: 30, color: "text-blue-400", bgColor: "bg-blue-400/10" },
  { id: "iroas" as const, name: "Ήρωας", emoji: "🛡️", minWins: 55, color: "text-blue-500", bgColor: "bg-blue-500/10" },
  { id: "iroas" as const, name: "Πρωταθλητής", emoji: "🏅", minWins: 90, color: "text-purple-500", bgColor: "bg-purple-500/10" },
  { id: "thrylos" as const, name: "Μέντορας", emoji: "⭐", minWins: 140, color: "text-purple-400", bgColor: "bg-purple-400/10" },
  { id: "thrylos" as const, name: "Grandmaster", emoji: "🎖️", minWins: 215, color: "text-yellow-500", bgColor: "bg-yellow-500/10" },
  { id: "theos" as const, name: "Θρύλος", emoji: "👑", minWins: 315, color: "text-amber-500", bgColor: "bg-amber-500/10" },
  { id: "theos" as const, name: "Θεός", emoji: "🔱", minWins: 465, color: "text-red-500", bgColor: "bg-red-500/10" },
];

export const TAVLI_RANK_TIERS = [
  { id: "archarios" as const, name: "Τσιράκι του καφετζή", emoji: "🫖", iconUrl: "/rank-icons/tsiraki-icon.png", minWins: 0, color: "text-muted-foreground", bgColor: "bg-muted" },
  { id: "archarios" as const, name: "Μαθητευόμενος", emoji: "📖", minWins: 30, color: "text-stone-400", bgColor: "bg-stone-500/10" },
  { id: "machitis" as const, name: "Έμπειρος παίκτης", emoji: "🧐", minWins: 75, color: "text-emerald-500", bgColor: "bg-emerald-500/10" },
  { id: "machitis" as const, name: "Απαίχτος ταβλαδόρος", emoji: "🎲", minWins: 200, color: "text-blue-400", bgColor: "bg-blue-400/10" },
  { id: "iroas" as const, name: "Θρύλος του τάβλι", emoji: "🏛️", minWins: 350, color: "text-blue-500", bgColor: "bg-blue-500/10" },
  { id: "iroas" as const, name: "Αρχιταβλαδόρος", emoji: "👑", minWins: 550, color: "text-purple-500", bgColor: "bg-purple-500/10" },
  { id: "thrylos" as const, name: "Μέντορας ταβλιού", emoji: "🎓", minWins: 800, color: "text-purple-400", bgColor: "bg-purple-400/10" },
  { id: "thrylos" as const, name: "Νονός του τάβλι", emoji: "🎩", minWins: 1100, color: "text-yellow-500", bgColor: "bg-yellow-500/10" },
  { id: "theos" as const, name: "Πρύτανης του τάβλι", emoji: "🏛️", minWins: 1500, color: "text-amber-500", bgColor: "bg-amber-500/10" },
  { id: "theos" as const, name: "Αυτοκράτορας του τάβλι", emoji: "👑", minWins: 2000, color: "text-red-500", bgColor: "bg-red-500/10" },
];

/** Calculate rank index (0-9) from total PvP wins for a given tier list */
export function getRankIndexFromWins(totalWins: number, tiers: typeof TAVLI_RANK_TIERS): number {
  let idx = 0;
  for (let i = tiers.length - 1; i >= 0; i--) {
    if (totalWins >= tiers[i].minWins) { idx = i; break; }
  }
  return idx;
}

// Imperium 1800-specific military ranks (used only in Imperium 1800 context)
export const STRATEGO_RANK_TIERS = [
  { 
    id: "archarios" as const, 
    name: "Κατάσκοπος", 
    emoji: "🕵️", 
    minWins: 0, 
    color: "text-muted-foreground",
    bgColor: "bg-muted",
  },
  { 
    id: "archarios" as const, 
    name: "Ανιχνευτής", 
    emoji: "🔭", 
    minWins: 5, 
    color: "text-stone-400",
    bgColor: "bg-stone-500/10",
  },
  { 
    id: "machitis" as const, 
    name: "Ναρκαλιευτής", 
    emoji: "💣", 
    minWins: 15, 
    color: "text-emerald-500",
    bgColor: "bg-emerald-500/10",
  },
  { 
    id: "machitis" as const, 
    name: "Λοχίας", 
    emoji: "⚔️", 
    minWins: 30, 
    color: "text-blue-400",
    bgColor: "bg-blue-400/10",
  },
  { 
    id: "iroas" as const, 
    name: "Υπολοχαγός", 
    emoji: "🗡️", 
    minWins: 55, 
    color: "text-blue-500",
    bgColor: "bg-blue-500/10",
  },
  { 
    id: "iroas" as const, 
    name: "Λοχαγός", 
    emoji: "🛡️", 
    minWins: 90, 
    color: "text-purple-500",
    bgColor: "bg-purple-500/10",
  },
  { 
    id: "thrylos" as const, 
    name: "Ταγματάρχης", 
    emoji: "⭐", 
    minWins: 140, 
    color: "text-purple-400",
    bgColor: "bg-purple-400/10",
  },
  { 
    id: "thrylos" as const, 
    name: "Συνταγματάρχης", 
    emoji: "🎖️", 
    minWins: 215, 
    color: "text-yellow-500",
    bgColor: "bg-yellow-500/10",
  },
  { 
    id: "theos" as const, 
    name: "General", 
    emoji: "👑", 
    minWins: 315, 
    color: "text-amber-500",
    bgColor: "bg-amber-500/10",
  },
  { 
    id: "theos" as const, 
    name: "Στρατάρχης", 
    emoji: "🏅", 
    minWins: 465, 
    color: "text-red-500",
    bgColor: "bg-red-500/10",
  },
];

// Νίκες που χρειάζονται ανά βαθμίδα (escalating):
// Αρχάριος→Παίκτης: 5, Παίκτης→Μαχητής: 10, →Δυναμίτης: 15,
// →Ήρωας: 25, →Πρωταθλητής: 35, →Μέντορας: 50,
// →Grandmaster: 75, →Θρύλος: 100, →Θεός: 150

export function getRankForPoints(points: number) {
  for (let i = RANK_TIERS.length - 1; i >= 0; i--) {
    if (points >= RANK_TIERS[i].minWins) return RANK_TIERS[i];
  }
  return RANK_TIERS[0];
}

export function getNextRank(points: number) {
  for (const tier of RANK_TIERS) {
    if (points < tier.minWins) return tier;
  }
  return null; // Already max rank
}

export function getRankProgress(points: number) {
  const current = getRankForPoints(points);
  const next = getNextRank(points);
  if (!next) return 100;
  const range = next.minWins - current.minWins;
  const progress = points - current.minWins;
  return Math.round((progress / range) * 100);
}

// Υπολογισμός rank_points: νίκες - ήττες (min 0)
export function calculateRankPoints(
  multiplayerWins: number, aiWins: number,
  multiplayerLosses: number = 0, aiLosses: number = 0
): number {
  const gained = multiplayerWins * WIN_VALUES.MULTIPLAYER + aiWins * WIN_VALUES.AI;
  const lost = multiplayerLosses * Math.abs(LOSS_VALUES.MULTIPLAYER) + aiLosses * Math.abs(LOSS_VALUES.AI);
  return Math.max(0, Math.floor(gained - lost));
}

export const GAME_VARIANTS = {
  portes: { name: "Πόρτες", emoji: "🎲", description: "Το κλασικό ελληνικό τάβλι" },
  plakoto: { name: "Πλακωτό", emoji: "📌", description: "Κλείδωσε τα πούλια του αντιπάλου" },
  fevga: { name: "Φεύγα", emoji: "🏃", description: "Τρέξε να φύγεις πρώτος" },
} as const;

export const ENTRY_FEES = [
  { amount: 50, label: "50 μάρκες", emoji: "🪙" },
  { amount: 100, label: "100 μάρκες", emoji: "🪙" },
  { amount: 250, label: "250 μάρκες", emoji: "🪙" },
  { amount: 500, label: "500 μάρκες", emoji: "🪙" },
];
